import { ProductRequestModel } from "libs/models/products";
import { ValidationModel } from "libs/models/validate-model";
import { ProductsStore } from "store/slices/products";
import { decimalNumberRegex, numberRegex } from "utils/regex";
import translate from "utils/translations";

export const validateAddProductState = (
  state: ProductsStore
): ValidationModel<ProductRequestModel> => {
  let validationModel = {} as ValidationModel<ProductRequestModel>;
  if (!state.isValidating) {
    return validationModel;
  }
  if (!state.newProductData.name) {
    validationModel.name = translate("Required_Text", "Required Field");
  }
  if (state.newProductData.name && state.newProductData.name.length > 200) {
    validationModel.name = translate("Long_Text", "Text is too long");
  }
  if (
    state.newProductData.name &&
    state.newProductData.name !== "" &&
    state.newProductData.name.length < 2
  ) {
    validationModel.name = translate("Short_Text", "Text is too short");
  }
  if (!state.newProductData.validityPeriod) {
    validationModel.validityPeriod = translate(
      "Required_Text",
      "Required Field"
    );
  }
  if (!state.newProductData.amount) {
    validationModel.amount = translate("Required_Text", "Required Field");
  }

  if (
    state.newProductData.amount !== undefined &&
    !numberRegex.test(state.newProductData.amount.toString())
  ) {
    validationModel.amount = translate(
      "Invalid_Data_Text",
      "Invalid Data TODO"
    );
  }
  if (
    state.newProductData.validityPeriod !== undefined &&
    !numberRegex.test(state.newProductData.validityPeriod.toString())
  ) {
    validationModel.validityPeriod = translate(
      "Invalid_Data_Text",
      "Invalid Data TODO"
    );
  }
  if (
    state.newProductData.productItemsNumber !== undefined &&
    !numberRegex.test(state.newProductData.productItemsNumber.toString())
  ) {
    validationModel.productItemsNumber = translate(
      "Invalid_Data_Text",
      "Invalid Data TODO"
    );
  }
  if (
    state.newProductData.clickingFees !== undefined &&
    !decimalNumberRegex.test(state.newProductData.clickingFees.toString())
  ) {
    validationModel.clickingFees = translate(
      "Invalid_Data_Text",
      "Invalid Data TODO"
    );
  }
  return validationModel;
};
